import React from 'react';
import Helmet from 'react-helmet';
import rehypeReact from 'rehype-react';
import _ from 'lodash';

import Header from '../components/Header';
import Carousel from '../components/Carousel';
import TagsPost from '../components/TagsPost';
import PostsLinked from '../components/PostsLinked';
import OthersPosts from '../components/OthersPosts';

import './styles/post.scss';

// If needed to render a react component set in markdown file
const renderAst = new rehypeReact({
  createElement: React.createElement,
  // components: { "carousel": Carousel },
}).Compiler;

const PostTemplate = ({ data, pathContext, defaultBanner }) => {
  const { site, post, imagesSharp, legendsMarkdown} = data;

  const { othersPosts, previousPost, nextPost } = pathContext;

  const titleBlog = site.siteMetadata.title;
  const { html, frontmatter } = post;
  const { title, banner, tags, reading_duration } = frontmatter;

  const postBanner = (banner)
  ? banner.childImageSharp.sizes
  : defaultBanner.sizes;

  const legendsIncoming = (legendsMarkdown) ? legendsMarkdown.edges : [];

  const legends = legendsIncoming.reduce((memo, legend) => {
    const { node } = legend;
    const { fields, frontmatter: infos } = node;
    const path = (fields) ? fields.slug : "";

    const repositories = path.split('/').filter(e => e !== "");

    const image = repositories[repositories.length - 1];
    memo[image] = infos;

    return memo;
  }, []);

  const images = imagesSharp.edges.map(data => {
    const originalShortName = data.node.imageData.originalName.split('.')[0];

    var description = '';
    if (Object.keys(legends).indexOf(originalShortName) !== -1) {
      description = legends[originalShortName].description
    }

    const { src } = data.node.imageData;

    return {
      original: src,
      thumbnail: src,
      originalTitle: originalShortName,
      originalAlt: originalShortName,
      description: description,
    }
  });

  const hasPreviousPost = !_.isEmpty(previousPost);
  const hasNextPost = !_.isEmpty(nextPost);

  const previousPostTitle = (hasPreviousPost) ? previousPost.frontmatter.title : '';
  const previousPostLink = (hasPreviousPost) ? previousPost.fields.slug : '';
  const nextPostTitle = (hasNextPost) ? nextPost.frontmatter.title : '';
  const nextPostLink = (hasNextPost) ? nextPost.fields.slug : '';

  return (
    <div className="postPage">
        <Helmet title={`${title} - ${titleBlog} `} />

        {
          postBanner &&
            <Header banner={postBanner} />
        }
        <div className="postPage-mainContent">
          <div className="postPage-mainContent-header">
            <div className="postPage-mainContent-title">
              <h1 className="mainTitle">{title}</h1>
            </div>

            <div className="postPage-mainContent-infos">
              <TagsPost tags={tags} />
              <p className="postPage-mainContent-reading_duration">
                Temps de lecture: {reading_duration}
              </p>
            </div>
          </div>

          <div
            className="postPage-postContent"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>

        <div className="postPage-Carousel">
          <Carousel images={images} />
        </div>

        <div className="postPage-mainContent">
          <PostsLinked
            previousPostTitle={previousPostTitle}
            previousPostLink={previousPostLink}
            nextPostTitle={nextPostTitle}
            nextPostLink={nextPostLink}
          />
          
          <hr />

          <div className="postPage-othersPosts">
            <h2>Voir d'autres articles</h2>
            <OthersPosts othersPosts={othersPosts} />
          </div>
        </div>
    </div>
  );
};

export default PostTemplate;

export const query = graphql`
  query PostQuery(
    $slug: String!,
    $imagesDir: String!,
    $slugLegend: String!
  ) {
    site {
      siteMetadata {
        title
      }
    }
    post: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      # htmlAst
      frontmatter {
        title
        tags
        banner {
          childImageSharp {
            sizes(maxWidth: 1400, maxHeight: 300, cropFocus: CENTER) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        reading_duration
      }
    }
    legendsMarkdown: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: $slugLegend}}
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            title
            description
          }
        }
      }
    }
    imagesSharp: allImageSharp(filter: {
      id: {
        regex: $imagesDir
      }
    }) {
      edges {
        node {
          ... on ImageSharp {
            imageData: resolutions(height: 700, width: 1400, cropFocus: CENTER) {
              src
              originalName
            }
          }
        }
      }
    }
  }
`;

            


// WEBPACK FOOTER //
// ./src/templates/post.jsx